import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { accessPermitRelationTypes } from "helpers/enums";
import { rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";

export class AccessPermits extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
            },
            {
                Header: "Изображение",
                accessor: "image",
                filterable: true,
                Cell: ({ value }) => value && <img src={value.accessUrlLink} width={20} alt={value.originalFileName || ""} />,
                CSVExport: ({ value }) => value?.originalFileName,
            },
            {
                Header: "Тип допуска",
                accessor: "relationType",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "status" },
                            options: accessPermitRelationTypes,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(accessPermitRelationTypes, value),
                CSVExport: ({ value }) => enumLabel(accessPermitRelationTypes, value),
            },
        ];
    }

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(AccessPermits, "access-permits");
